<template>
  <div class="sms-cell">
    <div class="sms-cell-top">
      <span class="cell-level" :class="getRiskLevelBgColor(cardData)"></span>
      <span class="cell-title">{{ coreRisk.name }}</span>
    </div>
    <div class="sms-cell-bottom">
      <div class="achievement-index-left">
        <div class="index-name">危险源 :</div>
        <div class="index-name">KPI :</div>
      </div>
      <div class="achievement-index-right">
        <div class="index-value">
          <span v-for="(color, index) in cardData.dangerColorList" :key="'danger-' + color" :class="'risk-level-color-' + color">
            {{ index > 0 ? ' / ' : '' }}{{ cardData.danger[color] }}
          </span>
        </div>
        <div class="index-value">
          <span class="risk-level-color-red">{{ cardData.kpi.red }}</span>
          /
          <span class="risk-level-color-yellow">{{ cardData.kpi.yellow }}</span>
          /
          <span class="risk-level-color-blue">{{ cardData.kpi.blue }}</span>
          /
          <span class="risk-level-color-green">{{ cardData.kpi.green }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";

export default {
  props: {
    //核心风险
    coreRisk: Object,
  },
  data() {
    return {
      cardData: {
        danger: {
          red: "..",
          orange: "..",
          yellow: "..",
          blue: "..",
          green: "..",
        },
        kpi: {
          red: "..",
          yellow: "..",
          blue: "..",
          green: "..",
        },
        dangerColorList: []
      }
    }
  },
  mounted() {
    getRequest("risk/core/card", {
      coreRisk: this.coreRisk.code
    }).then(res => {
      this.cardData = res.data;
    })
  },
  methods: {
    getRiskLevelBgColor(data) {
      return this.$util.getRiskLevelBgColor(data ? data.levelColor : null);
    },
  }
}
</script>

<style scoped lang="less">
.sms-cell-top {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.cell-level {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.cell-title {
  margin: 0 8px;
  font-weight: bold;
  font-size: 14px;
}

.sms-cell-bottom {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.achievement-index-right {
  margin-left: 4px;
}

.index-name, .index-value {
  line-height: 20px;
}

.index-value span {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/risk/CoreRiskCard.vue